import {Component} from '@angular/core';
import { FieldType } from '@ngx-formly/core';

  @Component({
    selector: 'new-custom-radiobutton',
    template: `
    <h3 class="title-blk">{{to.label}}*</h3>
    <div class="wrapper">
      <div class="sub_blk" *ngFor="let option of data1; let i = index"  (change)="onChange(option.value)">
        <input type="radio" name="vpcType" id="{{option.value}}" class="radio_blk" 
        [ngClass]="{'checked': i===isSelected}">
        <label for="{{option.value}}" class="option {{option.value}}">
         <span>{{option.label}}</span>
        </label>
      </div>
    </div>
    `,
    standalone: false
})
   
  export class CustomRadioButtonFormlyType extends FieldType {
  
    isSelected:any;
    data1=[
      { value: 'Onsite1', label: 'Onsite' },
      { value: 'Offsite Road1', label: 'Offsite Road' },
    ]
    constructor() {
      super();
    }
    
    onChange(option: any) {
      this.formControl.patchValue(option);
      this.formControl.markAsTouched();
    }
    onSelect(event){
      this.isSelected=event;
    }
  }
  